import _ from 'lodash';
import { ColumnStatus } from './programTypes';

const DEFAULT_COLUMN_STATUS: ColumnStatus = 'design';

const STATUS_COLUMN_MAP: Record<string, ColumnStatus> = {
  design: 'design',
  designed: 'design',
  published: 'published',
  invited: 'invited',
  actived: 'active',
  active: 'active'
};

const TYPE_LABEL_OVERRIDES: Record<string, string> = {
  'masterclass&mentorship': 'Guided Course',
  masterclass: 'Course',
  mentorship: 'Mentorship'
};

const BADGE_STYLES: Record<string, { background: string; color: string }> = {
  Mentorship: { background: '#8E44FF', color: '#FFFFFF' },
  Course: { background: '#F0B80D', color: '#0F0F0F' },
  'Guided Course': { background: '#F15A26', color: '#FFFFFF' }
};

export const isDesignedProgram = (status?: string) => (status || '').toLowerCase() === 'designed';

export const getColumnStatus = (status?: string): ColumnStatus => {
  const normalized = (status || '').toLowerCase();
  return STATUS_COLUMN_MAP[normalized] || DEFAULT_COLUMN_STATUS;
};

const inferTypeFromGoals = (goals: any) => {
  if (!goals) return 'mentorship';
  if (typeof goals === 'object' && Object.keys(goals).length === 0) return 'mentorship';
  return 'masterclass';
};

export const getProgramTypeLabel = (type?: string, goals?: any) => {
  if (type) return TYPE_LABEL_OVERRIDES[type] || _.startCase(type);
  return inferTypeFromGoals(goals) === 'masterclass' ? 'Course' : 'Mentorship';
};

export const getBadgeStyle = (label: string) => BADGE_STYLES[label] || { background: '#F0B80D', color: '#0F0F0F' };
